import React, { useContext } from 'react';

// DEPENDENCIES
import trim from 'lodash/trim';

// GLOBAL HELPERS
import { RecordContext } from 'helpers/getRecordData';

// BOOTSTRAP COMPONENTS
import { Accordion } from 'react-bootstrap';

// CORE COMPONENTS
import Form from 'core/form/Form';

// STYLES
import styles from './activityLog.module.scss';
import { formatDateTime } from 'functions';

// MAIN COMPONENT
const AcitivtyLog = () => {

  // CONTEXT
  const { record: { activity_log } = {} } = useContext(RecordContext);

  // RENDER
  return(
    <Accordion className={styles.accordion}>
      <Accordion.Item className="border-0" eventKey="0">
        <Accordion.Button className="p-0 bg-transparent border-0 shadow-none">
          <h4>Recent Activity</h4>
        </Accordion.Button>
        <Accordion.Body className="p-0">
          <div className={styles.inner}>
            {activity_log.map((item,index) => (
              <div key={`activity_log-${index}`} className={styles.item}>
                <div className={styles.header}>
                  <div><a href={`mailto:${item.activity_log_user_email_address}`} className={styles.mailLink}>{item.activity_log_user_full_name}</a> {item.activity_type}</div>
                  <div className="caption">{formatDateTime(item.date_updated)}</div>
                </div>
                {item.field_label &&
                  <div className={styles.fieldInfo}>
                    <Form.Row>
                      <Form.Label label="Field" className={styles.infoLabel} col={{className: styles.infoLabelCol}} vertical cols={{ sm: 8, xs: 24 }} />
                      <Form.Label label="Original Value" className={styles.infoLabel} col={{className: styles.infoLabelCol}}  vertical cols={{ sm: 8, xs: 24 }} />
                      <Form.Label label="New Value" className={styles.infoLabel} col={{className: styles.infoLabelCol}}  vertical cols={{ sm: 8, xs: 24 }} />
                      <Form.PlainText
                        value={trim(item.field_label) || '-'}
                        cols={{ sm: 8, xs: 24 }}
                      />
                      <Form.PlainText
                        value={trim(item.orig_valuetext) || '-'}
                        cols={{ sm: 8, xs: 24 }}
                      />
                      <Form.PlainText
                        value={trim(item.new_valuetext) || '-'}
                        cols={{ sm: 8, xs: 24 }}
                      />
                    </Form.Row>
                  </div>
                }
              </div>
            ))}
          </div>
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  )
}

// EXPORT
export default AcitivtyLog;
